// import React, { useEffect, useState } from "react";
// //import ListView from "../ListView";
// import MyVehicleListView from "../sellerProfile/MyVehicleListView";
// import { useLanguage } from "../../context/LanguageContext";
// import translations from "../../locals/translations.json";
// import api from "../../lib/api.ts";
// import Pagination from "../common/Pagination.jsx";

// const MyVehicles = () => {
//   const [allVehicles, setAllVehicles] = useState([]); // Store all vehicles for client-side pagination
//   const [vehicles, setVehicles] = useState([]); // Current page vehicles
//   const [filter, setFilter] = useState("all");
//   const [paymentStatusFilter, setPaymentStatusFilter] = useState("all");
//   const [currentPage, setCurrentPage] = useState(1);
//   const vehiclesPerPage = 15;
//   const [filterCounts, setFilterCounts] = useState({});
//   const [paymentStatusCounts, setPaymentStatusCounts] = useState({
//     all: 0,
//     pending: 0,
//     partial: 0,
//     paid: 0,
//     cancelled: 0,
//     refunded: 0
//   });

//   // Language support
//   const { language, translate } = useLanguage();
//   const isRTL = language === "ar";

//   // Read userId from localStorage
//   const authUser = localStorage.getItem("authUser");
//   const user = authUser ? JSON.parse(authUser) : null;
//   const userId = user ? user.id : null;

//   useEffect(() => {
//     const fetchCommissions = async () => {
//       const response = await api.get(`/sellers/commissions`);
//       console.log("response",response.data)
//     }
//     fetchCommissions();
//   })

//   // Fetch payment status counts when sold tab is active
//   useEffect(() => {
//     const fetchPaymentStatusCounts = async () => {
//       if (filter === "sold") {
//         try {
//           // Fetch all sold vehicles to count payment statuses
//           const response = await api.get(`/sellers/vehicles`, {
//             params: {
//               page: 1,
//               limit: 1000,
//               orderBy: 'id',
//               order: 'asc',
//               type: 'sold'
//             }
//           });

//           if (response.data && response.data.data) {
//             const soldVehicles = response.data.data;

//             // Count vehicles by payment status
//             const counts = {
//               all: soldVehicles.length,
//               pending: 0,
//               partial: 0,
//               paid: 0,
//               cancelled: 0,
//               refunded: 0
//             };

//             soldVehicles.forEach(vehicle => {
//               // Check if vehicle has buyerInvoiceDetails to determine payment status
//               if (vehicle.buyerInvoiceDetails && vehicle.buyerInvoiceDetails.length > 0) {
//                 const invoice = vehicle.buyerInvoiceDetails[0];
//                 const paymentStatus = invoice.invoicePaymentStatus;

//                 switch(paymentStatus) {
//                   case 1:
//                     counts.pending++;
//                     break;
//                   case 2:
//                     counts.partial++;
//                     break;
//                   case 3:
//                     counts.paid++;
//                     break;
//                   case 4:
//                     counts.cancelled++;
//                     break;
//                   case 5:
//                     counts.refunded++;
//                     break;
//                   default:
//                     counts.pending++; // Default to pending if status is unknown
//                 }
//               } else {
//                 // If no invoice details, consider as pending
//                 counts.pending++;
//               }
//             });

//             setPaymentStatusCounts(counts);
//           }
//         } catch (error) {
//           console.error("Error fetching payment status counts:", error);
//         }
//       }
//     };

//     fetchPaymentStatusCounts();
//   }, [filter]);

//   useEffect(() => {
//     const fetchVehicles = async () => {
//       try {
//         // Build filter parameters - fetch all vehicles for client-side pagination
//         const filterParams = {
//           page: 1, // Always fetch from page 1
//           limit: 1000,
//           orderBy: 'id',
//           order: 'asc',
//         };

//         // Add filters object for nested parameters
//         filterParams.filters = {};

//         // Add filter-specific parameters based on product statuses
//         if (filter === "stock") {
//           // For stock filter, we'll fetch all vehicles and filter on client side
//           // to include stock and buy-now vehicles
//         } else if (filter === "auction") {
//           filterParams.type = "auction";
//         } else if (filter === "waiting") {
//           filterParams.type = "waiting";
//         } else if (filter === "sold") {
//           filterParams.type = "sold";
//         } else if (filter === "returned") {
//           filterParams.type = "returned";
//         } else if (filter === "under-approval") {
//           filterParams.type = "under-approval";
//         } else if (filter === "rejected") {
//           filterParams.type = "rejected";
//         } else if (filter === "awaiting-arrival") {
//           filterParams.type = "awaiting-arrival";
//         }

//         // Add invoicePaymentStatus filter for sold vehicles
//         if (filter === "sold" && paymentStatusFilter !== "all") {
//           filterParams.filters.invoicePaymentStatus = paymentStatusFilter;
//         }

//         // Use the new sellers/vehicles endpoint with pagination and filtering
//         const response = await api.get(`/sellers/vehicles`, {
//           params: filterParams,

//         });

//         console.log("response",response)

//         // const responseData = await api.get(`/seller/${user.seller.id}/totalcommissions`)
//         // console.log("responseData",responseData)

//         if (response.data && response.data.data) {
//           // Handle stock filter only (all tab shows all vehicles without filtering)
//           let filteredData = response.data.data;
//           if (filter === "stock") {
//             // For stock filter, include vehicles with Stock or Buy Now status
//             filteredData = response.data.data.filter(vehicle => {
//               const productStatus = vehicle.ProductStatus?.name || vehicle.ProductStatus;
//               return productStatus === "Stock" || productStatus === "Buy Now";
//             });
//           }

//           // Map the API response keys to match VehicleListCard expected keys
//           const allMappedVehicles = filteredData.map((vehicle) => {
//             return {
//               id: vehicle?.id || vehicle?._id,
//               title: vehicle?.name || "",
//               slug: vehicle.slug ,
//               lotNo: vehicle?.lotNumber || "-",
//               vin: vehicle?.vinNumber || "-",
//               condition: vehicle?.condition || "",
//               miles: vehicle?.mileage || 0,
//               cylinder: vehicle?.cylinder?.name || vehicle?.cylinder || "-",
//               fuelType: vehicle?.fuelType?.name || vehicle?.fuelType || "-",
//               engine: vehicle?.engine?.name || vehicle?.engine || "-",
//               startBidding: vehicle?.startingBid || vehicle?.startBidding || 0,
//               currentBidding: vehicle?.latestBid || vehicle?.currentBidding || vehicle?.startingBid || 0,
//               image: vehicle?.images?.[0]?.imageUrl ,
//               isRunAndDrive: vehicle?.isRunAndDrive || vehicle?.runsAndDrives || false,
//               sellerName: vehicle?.seller?.user?.name ,
//               highlights: vehicle?.Highlight ? [vehicle?.Highlight] : [],
//               ProductStatus: vehicle?.ProductStatus?.name || vehicle?.ProductStatus,
//               rejectionReason: vehicle?.rejectionNotes[0]?.rejectionNote  || "",
//               auctionName: vehicle?.auctionLanesVehicles?.[0]?.auctionLane?.auction?.name || "-",
//               showAuctionColumn: filter === "auction",
//               soldPrice: vehicle?.soldPrice,
//               updatedAt: vehicle?.updatedAt || vehicle?.updated_at || ""
//               };
//           });

//           // Store all filtered vehicles for client-side pagination
//           setAllVehicles(allMappedVehicles);

//           // Calculate total pages for client-side pagination
//           const totalFilteredVehicles = allMappedVehicles.length;
//           const totalPagesForFiltered = Math.ceil(totalFilteredVehicles / vehiclesPerPage);
//           setTotalPages(totalPagesForFiltered);
//         } else {
//           setAllVehicles([]);
//           setTotalPages(1);
//         }
//       } catch (err) {
//         console.error("Error fetching vehicles:", err);
//         setAllVehicles([]);
//         setTotalPages(1);
//       }
//     };
//     fetchVehicles();
//   }, [userId, filter, paymentStatusFilter]);

//   // Handle client-side pagination
//   useEffect(() => {
//     const startIndex = (currentPage - 1) * vehiclesPerPage;
//     const endIndex = startIndex + vehiclesPerPage;
//     const currentPageVehicles = allVehicles.slice(startIndex, endIndex);
//     setVehicles(currentPageVehicles);
//   }, [allVehicles, currentPage, vehiclesPerPage]);

//   // Fetch counts for all filters
//   useEffect(() => {
//     const fetchFilterCounts = async () => {
//       if (!userId) return;

//       try {
//         const filterTypes = [
//           'all', 'stock', 'auction', 'sold', 'returned', 'under-approval', 'waiting',
//           'rejected', 'awaiting-arrival'
//         ];

//         const counts = {};

//         // First, get counts for all individual filters (excluding 'all')
//         const individualFilters = filterTypes.filter(type => type !== 'all');

//         for (const filterType of individualFilters) {
//           const filterParams = {
//             page: 1,
//             limit: 1, // Just get count, not actual data
//             orderBy: 'id',
//             order: 'asc',
//           };

//           // Add filter-specific parameters
//           if (filterType === "stock") {
//             // For stock count, we need to get all vehicles and count stock and buy-now
//             // We'll handle this specially after the loop
//           } else if (filterType === "auction") {
//             filterParams.type = "auction";
//           } else if (filterType === "sold") {
//             filterParams.type = "sold";
//           } else if (filterType === "returned") {
//             filterParams.type = "returned";
//           } else if (filterType === "under-approval") {
//             filterParams.type = "under-approval";
//           } else if (filterType === "waiting") {
//             filterParams.type = "waiting";
//           } else if (filterType === "rejected") {
//             filterParams.type = "rejected";
//           } else if (filterType === "awaiting-arrival") {
//             filterParams.type = "awaiting-arrival";
//           }

//           const response = await api.get(`/sellers/vehicles`, {
//             params: filterParams,
//           });

//           counts[filterType] = response.data.total || response.data.data?.length || 0;
//         }

//         // Handle stock count specially - get all vehicles and count stock and buy-now
//         const allVehiclesResponse = await api.get(`/sellers/vehicles`, {
//           params: {
//             page: 1,
//             limit: 1000, // Get a large number to count all vehicles
//             orderBy: 'id',
//             order: 'asc',
//           },
//         });

//         if (allVehiclesResponse.data && allVehiclesResponse.data.data) {
//           const stockCount = allVehiclesResponse.data.data.filter(vehicle => {
//             const productStatus = vehicle.ProductStatus?.name || vehicle.ProductStatus;
//             return productStatus === "Stock" || productStatus === "Buy Now";
//           }).length;
//           counts['stock'] = stockCount;
//         }

//         // For "all" count, get the total count of all vehicles (including rejected)
//         const allVehiclesCountResponse = await api.get(`/sellers/vehicles`, {
//           params: {
//             page: 1,
//             limit: 1, // Just get count
//             orderBy: 'id',
//             order: 'asc',
//           },
//         });
//         counts['all'] = allVehiclesCountResponse.data.total || 0;

//         setFilterCounts(counts);
//       } catch (error) {
//         console.error("Error fetching filter counts:", error);
//       }
//     };

//     fetchFilterCounts();
//   }, [userId]);

//   // Since API handles filtering and pagination, we use vehicles directly
//   const currentVehicles = vehicles;

//   // Get total pages from API response
//   const [totalPages, setTotalPages] = useState(1);

//   // Reset to first page when filter changes
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [filter]);

//   // Reset payment status filter when main filter changes
//   useEffect(() => {
//     setPaymentStatusFilter("all");
//   }, [filter]);

//   return (
//     <>
//       <div className="bg-[#FFF9F9] rounded-lg shadow-md" dir={isRTL ? "rtl" : "ltr"} lang={language}>
//       {/* Header */}
//       <div className="bg-[#fcfcfc1f] text-gray-700 font-medium rounded-t-[16px] px-1 py-1">
//         <div className="p-[20px] text-lg rounded-t-[12px] font-semibold text-gray-700 bg-[#F153291F] border-b border-black pb-2">
//           <h2 className="text-base sm:text-lg font-semibold">
//             {translate("myVehicles.title")}
//           </h2>
//         </div>
//       </div>

//       <div className="px-3">
//         {/* Tabs */}
//         <div className="border-b border-gray-200">
//           <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 py-4">
//             <nav className="flex overflow-x-auto px-5 pb-2 lg:pb-0">
//               {[
//                 { key: 'all', label: translate("myVehicles.filters.all") },
//                 { key: 'stock', label: 'Yard' },
//                 { key: 'auction', label: 'Auction' },
//                 { key: 'sold', label: translate("myVehicles.filters.sold") },
//                 { key: 'returned', label: 'Returned' },
//                 { key: 'under-approval', label: 'Under Approval' },
//                 { key: 'waiting', label: 'Waiting' },
//                 { key: 'rejected', label: translate("myVehicles.filters.rejected") },
//                 { key: 'awaiting-arrival', label: 'Awaiting Arrival' },
//               ].map((tab) => (
//                 <button
//                   key={tab.key}
//                   onClick={() => setFilter(tab.key)}
//                   className={`flex-shrink-0 px-3 mx-1 py-2 rounded-full font-medium text-sm transition-all duration-200 ${
//                     filter === tab.key
//                       ? 'bg-gradient-to-r from-[#FF4A33] to-[#FFB74D] text-white shadow-md'
//                       : 'bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-800'
//                   }`}
//                 >
//                   {tab.label} ({filterCounts[tab.key] || 0})
//                 </button>
//               ))}
//             </nav>
//           </div>
//         </div>

//         {/* Payment Status Filter - Only show when Sold filter is active */}
//         {filter === "sold" && (
//           <div
//             className={`flex flex-wrap gap-3 mb-3 payment-status-filters py-2 ${
//               isRTL ? "flex-row-reverse justify-end" : "justify-start"
//             }`}
//           >

//             <button
//               onClick={() => setPaymentStatusFilter("all")}
//               className={`px-3 py-1 rounded-full font-medium text-sm transition-all duration-200 ${
//                 paymentStatusFilter === "all"
//                   ? "bg-gradient-to-r from-[#FF4A33] to-[#FFB74D] text-white shadow-md"
//                   : "bg-gray-100 text-gray-600 hover:bg-gray-200"
//               }`}
//             >
//               All Payments ({paymentStatusCounts.all})
//             </button>
//             <button
//               onClick={() => setPaymentStatusFilter("1")}
//               className={`px-3 py-1 rounded-full font-medium text-sm transition-all duration-200 ${
//                 paymentStatusFilter === "1"
//                   ? "bg-gradient-to-r from-[#FF4A33] to-[#FFB74D] text-white shadow-md"
//                   : "bg-gray-100 text-gray-600 hover:bg-gray-200"
//               }`}
//             >
//               Pending ({paymentStatusCounts.pending})
//             </button>
//             <button
//               onClick={() => setPaymentStatusFilter("2")}
//               className={`px-3 py-1 rounded-full font-medium text-sm transition-all duration-200 ${
//                 paymentStatusFilter === "2"
//                   ? "bg-gradient-to-r from-[#FF4A33] to-[#FFB74D] text-white shadow-md"
//                   : "bg-gray-100 text-gray-600 hover:bg-gray-200"
//               }`}
//             >
//               Partial Payment ({paymentStatusCounts.partial})
//             </button>
//             <button
//               onClick={() => setPaymentStatusFilter("3")}
//               className={`px-3 py-1 rounded-full font-medium text-sm transition-all duration-200 ${
//                 paymentStatusFilter === "3"
//                   ? "bg-gradient-to-r from-[#FF4A33] to-[#FFB74D] text-white shadow-md"
//                   : "bg-gray-100 text-gray-600 hover:bg-gray-200"
//               }`}
//             >
//               Paid ({paymentStatusCounts.paid})
//             </button>
//             <button
//               onClick={() => setPaymentStatusFilter("4")}
//               className={`px-3 py-1 rounded-full font-medium text-sm transition-all duration-200 ${
//                 paymentStatusFilter === "4"
//                   ? "bg-gradient-to-r from-[#FF4A33] to-[#FFB74D] text-white shadow-md"
//                   : "bg-gray-100 text-gray-600 hover:bg-gray-200"
//               }`}
//             >
//               Cancelled ({paymentStatusCounts.cancelled})
//             </button>
//             <button
//               onClick={() => setPaymentStatusFilter("5")}
//               className={`px-3 py-1 rounded-full font-medium text-sm transition-all duration-200 ${
//                 paymentStatusFilter === "5"
//                   ? "bg-gradient-to-r from-[#FF4A33] to-[#FFB74D] text-white shadow-md"
//                   : "bg-gray-100 text-gray-600 hover:bg-gray-200"
//               }`}
//             >
//               Refunded ({paymentStatusCounts.refunded})
//             </button>
//           </div>
//         )}

//         {/* Vehicle List */}
//         {currentVehicles.length > 0 ? (
//           <div className="bg-white rounded-lg border border-gray-200 overflow-hidden mb-6">
//             {/* Table Header */}
//             <div className="bg-gray-50 border-b border-gray-200 px-2 py-2">
//               <div className="grid grid-cols-12 gap-2 text-sm font-medium text-gray-700">
//                 <div className="col-span-1 ">Image</div>
//                 <div className="col-span-3">Vehicle Details</div>
//                 {filter === "rejected" ? (
//                   <div className="col-span-7 text-left">Rejection Reason</div>
//                 ) : (
//                   <>
//                     <div className="col-span-1 text-left  ">Miles</div>
//                     <div className="col-span-1 text-left">Fuel</div>
//                     <div className="col-span-1 text-left">Cyl</div>
//                     <div className="col-span-1 text-left ">Eng</div>
//                     <div className="col-span-1 text-left ">Updated At</div>
//                     {filter === "auction" && (
//                       <div className="col-span-1"> Auction</div>
//                     )}
//                     <div className="col-span-1"></div>
//                   </>
//                 )}
//                 <div className="col-span-1 text-right">Actions</div>
//               </div>
//             </div>

//             {/* Vehicle Items */}
//             <div className="divide-y divide-gray-200">
//               {currentVehicles.map((vehicle) => (
//                 <MyVehicleListView key={vehicle.id} vehicle={vehicle} />
//               ))}
//             </div>
//           </div>
//         ) : (
//           <div className="text-center py-12 bg-white rounded-lg border border-gray-200 mb-6">
//             <div className="text-gray-400 mb-4">
//               <svg className="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1m-1-1v-4a1 1 0 011-1h2a1 1 0 011 1v4m-6 0V9a1 1 0 011-1h2a1 1 0 011 1v2" />
//               </svg>
//             </div>
//             <h3 className="text-lg font-medium text-gray-900 mb-2">No Vehicles Found</h3>
//             <p className="text-gray-500 arabic-text">{translate("myVehicles.noVehiclesFound")}</p>
//           </div>
//         )}

//       </div>
//     </div>

//         <div className="mb-6">
//           <Pagination
//             totalPages={totalPages}
//             currentPage={currentPage}
//             setCurrentPage={setCurrentPage}
//           />
//         </div>
//         </>
//   );
// };

// export default MyVehicles;

import React, { useEffect, useState } from "react";
//import ListView from "../ListView";
import MyVehicleListView from "../sellerProfile/MyVehicleListView";
import { useLanguage } from "../../context/LanguageContext";
import translations from "../../locals/translations.json";
import api from "../../lib/api.ts";
import Pagination from "../common/Pagination.jsx";

const MyVehicles = () => {
  const [allVehicles, setAllVehicles] = useState([]); // Store all vehicles for client-side pagination
  const [vehicles, setVehicles] = useState([]); // Current page vehicles
  const [filter, setFilter] = useState("all");
  const [paymentStatusFilter, setPaymentStatusFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const vehiclesPerPage = 15;
  const [filterCounts, setFilterCounts] = useState({});
  const [paymentStatusCounts, setPaymentStatusCounts] = useState({
    all: 0,
    pending: 0,
    partial: 0,
    paid: 0,
    cancelled: 0,
    refunded: 0,
  });

  // Language support
  const { language, translate } = useLanguage();
  const isRTL = language === "ar";

  // Read userId from localStorage
  const authUser = localStorage.getItem("authUser");
  const user = authUser ? JSON.parse(authUser) : null;
  const userId = user ? user.id : null;
  const sellerId = user ? user?.seller?.id : null;

  // const formatRejectionReason = (rawNote) => {
  //   if (!rawNote || typeof rawNote !== "string") return "";
  //   try {
  //     const lines = rawNote
  //       .split(/\r?\n/)
  //       .map((l) => l.trim())
  //       .filter(Boolean);
  //     let reason = "";
  //     let suggested = "";

  //     for (const line of lines) {
  //       if (/^Rejection\s*Reasons?/i.test(line)) {
  //         const idx = line.indexOf(":");
  //         reason = idx !== -1 ? line.slice(idx + 1).trim() : line.trim();
  //       } else if (/^Suggested\s*Reserve\s*Price/i.test(line)) {
  //         const idx = line.indexOf(":");
  //         let val = idx !== -1 ? line.slice(idx + 1).trim() : "";
  //         val = val.replace(/AED\s*/i, "").replace(/,/g, "");
  //         const num = Number(val);
  //         suggested = Number.isFinite(num) ? num.toLocaleString("en-US") : val;
  //       }
  //     }

  //     const reasonText = reason || rawNote;
  //     const suggestedText = suggested ? ` (Suggested:USD ${suggested})` : "";
  //     return `*Rejection Reason : ${reasonText}${suggestedText}`;
  //   } catch {
  //     return rawNote;
  //   }
  // };

  const formatRejectionReason = (rawNote) => {
    if (!rawNote || typeof rawNote !== "string") return "";

    try {
      const lines = rawNote
        .split(/\r?\n/)
        .map((l) => l.trim())
        .filter(Boolean);

      let reason = "";
      let suggested = "";
      let customReason = "";

      for (const line of lines) {
        if (/^Rejection\s*Reasons?/i.test(line)) {
          const idx = line.indexOf(":");
          reason = idx !== -1 ? line.slice(idx + 1).trim() : line.trim();
        } else if (/^Suggested\s*Reserve\s*Price/i.test(line)) {
          const idx = line.indexOf(":");
          let val = idx !== -1 ? line.slice(idx + 1).trim() : "";
          //  val = val.replace(/AED\s*/i, "").replace(/,/g, "");

          val = val.replace(/^[A-Z]{3}\s*/i, "").replace(/,/g, "");
          const num = Number(val);
          suggested = Number.isFinite(num) ? num.toLocaleString("en-US") : val;
        } else if (/^Custom\s*Reason/i.test(line)) {
          const idx = line.indexOf(":");
          customReason = idx !== -1 ? line.slice(idx + 1).trim() : "";
        }
      }

      let output = `*Rejection Reason : ${reason || rawNote}`;

      if (suggested) {
        output += ` (Suggested: USD ${suggested})`;
      }

      if (customReason) {
        output += ` | ${customReason}`;
      }

      return output;
    } catch {
      return rawNote;
    }
  };

  // useEffect(() => {
  //   const fetchCommissions = async () => {
  //     const response = await api.get(`/sellers/commissions`);
  //   };
  //   fetchCommissions();
  // });

  // Fetch payment status counts when sold tab is active
  useEffect(() => {
    const fetchPaymentStatusCounts = async () => {
      if (filter === "sold") {
        try {
          // Fetch all sold vehicles to count payment statuses
          const response = await api.get(`/sellers/vehicles`, {
            params: {
              page: 1,
              limit: 1000,
              orderBy: "id",
              order: "asc",
              type: "sold",
            },
          });

          if (response.data && response.data.data) {
            const soldVehicles = response.data.data;

            // Count vehicles by payment status
            const counts = {
              all: soldVehicles.length,
              pending: 0,
              partial: 0,
              paid: 0,
              cancelled: 0,
              refunded: 0,
            };

            soldVehicles.forEach((vehicle) => {
              // Check if vehicle has buyerInvoiceDetails to determine payment status
              if (
                vehicle.buyerInvoiceDetails &&
                vehicle.buyerInvoiceDetails.length > 0
              ) {
                const invoice = vehicle.buyerInvoiceDetails[0];
                // Use the correct data structure: buyerInvoice.invoicePaymentStatus.name
                const paymentStatusName =
                  invoice.buyerInvoice?.invoicePaymentStatus?.name;

                switch (paymentStatusName) {
                  case "Pending":
                    counts.pending++;
                    break;
                  case "Partial Payment":
                    counts.partial++;
                    break;
                  case "Paid":
                    counts.paid++;
                    break;
                  case "Cancelled":
                    counts.cancelled++;
                    break;
                  case "Refunded":
                    counts.refunded++;
                    break;
                  default:
                    counts.pending++; // Default to pending if status is unknown
                }
              } else {
                // If no invoice details, consider as pending
                counts.pending++;
              }
            });

            console.log("Payment status counts calculated:", counts);
            console.log(
              "Sold vehicles payment status breakdown:",
              soldVehicles.map((v) => ({
                id: v.id,
                name: v.name,
                paymentStatusName:
                  v.buyerInvoiceDetails?.[0]?.buyerInvoice?.invoicePaymentStatus
                    ?.name,
                hasInvoice: !!v.buyerInvoiceDetails?.length,
              })),
            );

            setPaymentStatusCounts(counts);
          }
        } catch (error) {
          console.error("Error fetching payment status counts:", error);
        }
      }
    };

    fetchPaymentStatusCounts();
  }, [filter]);

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        // Build filter parameters - fetch all vehicles for client-side pagination
        const filterParams = {
          page: 1, // Always fetch from page 1
          limit: 1000,
          orderBy: "id",
          order: "asc",
        };

        // Add filters object for nested parameters
        filterParams.filters = {};

        // Add filter-specific parameters based on product statuses
        if (filter === "stock") {
          // For stock filter, we'll fetch all vehicles and filter on client side
          // to include stock and buy-now vehicles
        } else if (filter === "auction") {
          filterParams.type = "auction";
        } else if (filter === "waiting") {
          filterParams.type = "waiting";
        } else if (filter === "sold") {
          filterParams.type = "sold";
        } else if (filter === "buy-now") {
          filterParams.type = "buy-now";
        } else if (filter === "returned") {
          filterParams.type = "returned";
        } else if (filter === "under-approval") {
          filterParams.type = "under-approval";
        } else if (filter === "rejected") {
          filterParams.type = "rejected";
        } else if (filter === "awaiting-arrival") {
          filterParams.type = "awaiting-arrival";
        }

        // Add invoicePaymentStatus filter for sold vehicles
        if (filter === "sold" && paymentStatusFilter !== "all") {
          filterParams.filters.invoicePaymentStatus = paymentStatusFilter;
        }

        // Use the new sellers/vehicles endpoint with pagination and filtering
        const response = await api.get(`/sellers/vehicles`, {
          params: filterParams,
        });

        // const responseData = await api.get(`/seller/${user.seller.id}/totalcommissions`)
        // console.log("responseData",responseData)

        if (response.data && response.data.data) {
          // Handle stock filter only (all tab shows all vehicles without filtering)
          let filteredData = response.data.data;
          if (filter === "stock") {
            // For stock filter, include vehicles with Stock or Buy Now status
            filteredData = response.data.data.filter((vehicle) => {
              const productStatus =
                vehicle.ProductStatus?.name || vehicle.ProductStatus;
              return productStatus === "Stock" || productStatus === "Buy Now";
            });
          }

          // Map the API response keys to match VehicleListCard expected keys
          const allMappedVehicles = filteredData.map((vehicle) => {
            const rawRejection =
              vehicle?.rejectionNotes?.[0]?.rejectionNote || "";
            const rejectionReasonFormatted =
              formatRejectionReason(rawRejection);
            return {
              id: vehicle?.id || vehicle?._id,
              title: vehicle?.name || "",
              slug: vehicle.slug,
              lotNo: vehicle?.lotNumber || "-",
              vin: vehicle?.vinNumber || "-",
              condition: vehicle?.condition || "",
              miles: vehicle?.mileage || 0,
              cylinder: vehicle?.cylinder?.name || vehicle?.cylinder || "-",
              fuelType: vehicle?.fuelType?.name || vehicle?.fuelType || "-",
              engine: vehicle?.engine?.name || vehicle?.engine || "-",
              startBidding: vehicle?.startingBid || vehicle?.startBidding || 0,
              currentBidding:
                vehicle?.latestBid ||
                vehicle?.currentBidding ||
                vehicle?.startingBid ||
                0,
              image: vehicle?.images?.[0]?.imageUrl,
              isRunAndDrive:
                vehicle?.isRunAndDrive || vehicle?.runsAndDrives || false,
              sellerName: vehicle?.seller?.user?.name,
              highlights: vehicle?.Highlight ? [vehicle?.Highlight] : [],
              ProductStatus:
                vehicle?.ProductStatus?.name || vehicle?.ProductStatus,
              rejectionReason: rejectionReasonFormatted,

              soldPrice: vehicle?.soldPrice,
              reservedPrice: vehicle?.reservedPrice || 0,
              updatedAt: vehicle?.updatedAt || vehicle?.updated_at || "",
            };
          });

          // Store all filtered vehicles for client-side pagination
          setAllVehicles(allMappedVehicles);

          // Calculate total pages for client-side pagination
          const totalFilteredVehicles = allMappedVehicles.length;
          const totalPagesForFiltered = Math.ceil(
            totalFilteredVehicles / vehiclesPerPage,
          );
          setTotalPages(totalPagesForFiltered);
        } else {
          setAllVehicles([]);
          setTotalPages(1);
        }
      } catch (err) {
        console.error("Error fetching vehicles:", err);
        setAllVehicles([]);
        setTotalPages(1);
      }
    };
    fetchVehicles();
  }, [userId, filter, paymentStatusFilter]);

  // Handle client-side pagination
  useEffect(() => {
    const startIndex = (currentPage - 1) * vehiclesPerPage;
    const endIndex = startIndex + vehiclesPerPage;
    const currentPageVehicles = allVehicles.slice(startIndex, endIndex);
    setVehicles(currentPageVehicles);
  }, [allVehicles, currentPage, vehiclesPerPage]);

  // Fetch counts for all filters
  useEffect(() => {
    const fetchFilterCounts = async () => {
      if (!sellerId) return;

      // Use aggregated counts endpoint to avoid multiple requests
      try {
        const res = await api.get(`/products/countsbyproductstatuses`, {
          params: { sellerId: sellerId },
        });

        const raw = Array.isArray(res.data?.data) ? res.data.data : res.data;

        const counts = {
          all: Object.values(raw).reduce(
            (sum, v) => sum + (Number(v.count) || 0),
            0,
          ),
          stock: raw["stock"].count || 0,
          "buy-now": raw["buy-now"].count || 0,
          auction: raw["auction"].count || 0,
          sold: raw["sold"].count || 0,
          returned: raw["returned"].count || 0,
          "under-approval": raw["under-approval"].count || 0,
          waiting: raw["waiting"].count || 0,
          rejected: raw["rejected"].count || 0,
          "awaiting-arrival": raw["awaiting-arrival"].count || 0,
        };

        setFilterCounts(counts);
        return; // Skip legacy multi-call code below
      } catch (error) {
        console.error("Error fetching aggregated filter counts:", error);
        // If this fails, fall through to legacy code below
      }

      // try {
      //   const filterTypes = [
      //     'all', 'stock', 'auction', 'sold', 'returned', 'under-approval', 'waiting',
      //     'rejected', 'awaiting-arrival'
      //   ];

      //   const counts = {};

      //   // First, get counts for all individual filters (excluding 'all')
      //   const individualFilters = filterTypes.filter(type => type !== 'all');

      //   for (const filterType of individualFilters) {
      //     const filterParams = {
      //       page: 1,
      //       limit: 1, // Just get count, not actual data
      //       orderBy: 'id',
      //       order: 'asc',
      //     };

      //     // Add filter-specific parameters
      //     if (filterType === "stock") {
      //       // For stock count, we need to get all vehicles and count stock and buy-now
      //       // We'll handle this specially after the loop
      //     } else if (filterType === "auction") {
      //       filterParams.type = "auction";
      //     } else if (filterType === "sold") {
      //       filterParams.type = "sold";
      //     } else if (filterType === "returned") {
      //       filterParams.type = "returned";
      //     } else if (filterType === "under-approval") {
      //       filterParams.type = "under-approval";
      //     } else if (filterType === "waiting") {
      //       filterParams.type = "waiting";
      //     } else if (filterType === "rejected") {
      //       filterParams.type = "rejected";
      //     } else if (filterType === "awaiting-arrival") {
      //       filterParams.type = "awaiting-arrival";
      //     }

      //     const response = await api.get(`/sellers/vehicles`, {
      //       params: filterParams,
      //     });

      //     counts[filterType] = response.data.total || response.data.data?.length || 0;
      //   }

      //   // Handle stock count specially - get all vehicles and count stock and buy-now
      //   const allVehiclesResponse = await api.get(`/sellers/vehicles`, {
      //     params: {
      //       page: 1,
      //       limit: 1000, // Get a large number to count all vehicles
      //       orderBy: 'id',
      //       order: 'asc',
      //     },
      //   });

      //   if (allVehiclesResponse.data && allVehiclesResponse.data.data) {
      //     const stockCount = allVehiclesResponse.data.data.filter(vehicle => {
      //       const productStatus = vehicle.ProductStatus?.name || vehicle.ProductStatus;
      //       return productStatus === "Stock" || productStatus === "Buy Now";
      //     }).length;
      //     counts['stock'] = stockCount;
      //   }

      //   // For "all" count, get the total count of all vehicles (including rejected)
      //   const allVehiclesCountResponse = await api.get(`/sellers/vehicles`, {
      //     params: {
      //       page: 1,
      //       limit: 1, // Just get count
      //       orderBy: 'id',
      //       order: 'asc',
      //     },
      //   });
      //   counts['all'] = allVehiclesCountResponse.data.total || 0;

      //   setFilterCounts(counts);
      // } catch (error) {
      //   console.error("Error fetching filter counts:", error);
      // }
    };

    fetchFilterCounts();
  }, [userId]);

  // Since API handles filtering and pagination, we use vehicles directly
  const currentVehicles = vehicles;

  // Get total pages from API response
  const [totalPages, setTotalPages] = useState(1);

  // Reset to first page when filter changes
  useEffect(() => {
    setCurrentPage(1);
  }, [filter]);

  // Reset payment status filter when main filter changes
  useEffect(() => {
    setPaymentStatusFilter("all");
  }, [filter]);

  return (
    <>
      <div
        className="bg-card rounded-lg shadow-md"
        dir={isRTL ? "rtl" : "ltr"}
        lang={language}
      >
        {/* Header */}

        <div className="bg-card font-medium rounded-t-[8px] sm:rounded-t-[16px]">
          <div className="flex flex-col lg:flex-row lg:items-center justify-between px-4 sm:px-5 py-3 sm:py-4 rounded-t-[8px] sm:rounded-t-[12px] bg-primary-soft gap-4 min-h-[120px] lg:min-h-[72px]">
            {/* Left Side Grouping */}
            <div className="flex flex-col justify-center">
              <h2 className="text-white text-base sm:text-lg font-semibold whitespace-nowrap">
                {translate("myVehicles.title")}
              </h2>
            </div>

            {/* Right Side Grouping (Kept for height and alignment consistency) */}
            <div className="flex flex-col md:flex-row items-start md:items-center gap-3 ms-auto lg:ms-0 w-full lg:w-auto"></div>
          </div>
        </div>

        <div className="px-3">
          {/* Tabs */}
          <div>
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2 py-4">
              <nav className="flex flex-wrap px-5 gap-2">
                {[
                  { key: "all", label: translate("myVehicles.filters.all") },
                  {
                    key: "stock",
                    label: translate("myVehicles.filters.stock"),
                  },
                  {
                    key: "auction",
                    label: translate("myVehicles.filters.auction"),
                  },
                  { key: "sold", label: translate("myVehicles.filters.sold") },
                  {
                    key: "buy-now",
                    label: translate("myVehicles.filters.buyNow"),
                  },
                  {
                    key: "returned",
                    label: translate("myVehicles.filters.returned"),
                  },
                  {
                    key: "under-approval",
                    label: translate("myVehicles.filters.underApproval"),
                  },
                  {
                    key: "waiting",
                    label: translate("myVehicles.filters.waiting"),
                  },
                  {
                    key: "rejected",
                    label: translate("myVehicles.filters.rejected"),
                  },
                  {
                    key: "awaiting-arrival",
                    label: translate("myVehicles.filters.awaitingArrival"),
                  },
                ].map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => setFilter(tab.key)}
                    className={`px-3 py-2 rounded-full font-medium text-sm transition-all duration-200 ${
                      filter === tab.key
                        ? "bg-gradient-to-r from-primary to-secondary text-white shadow-md"
                        : "bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-800"
                    }`}
                  >
                    {tab.label} ({filterCounts[tab.key] || 0})
                  </button>
                ))}
              </nav>
            </div>
          </div>

          {/* Payment Status Filter - Only show when Sold filter is active */}
          {filter === "sold" && (
            <div
              className={`flex flex-wrap gap-3 mb-3 payment-status-filters py-2 ${
                isRTL ? "flex-row-reverse justify-end" : "justify-start"
              }`}
            >
              <button
                onClick={() => setPaymentStatusFilter("all")}
                className={`px-3 py-1 rounded-full font-medium text-sm transition-all duration-200 ${
                  paymentStatusFilter === "all"
                    ? "bg-gradient-to-r from-primary to-secondary text-white shadow-md"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                }`}
              >
                {translate("myVehicles.paymentStatus.allPayments")} (
                {paymentStatusCounts.all})
              </button>
              <button
                onClick={() => setPaymentStatusFilter("1")}
                className={`px-3 py-1 rounded-full font-medium text-sm transition-all duration-200 ${
                  paymentStatusFilter === "1"
                    ? "bg-gradient-to-r from-primary to-secondary text-white shadow-md"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                }`}
              >
                {translate("myVehicles.paymentStatus.pending")} (
                {paymentStatusCounts.pending})
              </button>
              <button
                onClick={() => setPaymentStatusFilter("2")}
                className={`px-3 py-1 rounded-full font-medium text-sm transition-all duration-200 ${
                  paymentStatusFilter === "2"
                    ? "bg-gradient-to-r from-primary to-secondary text-white shadow-md"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                }`}
              >
                {translate("myVehicles.paymentStatus.partialPayment")} (
                {paymentStatusCounts.partial})
              </button>
              <button
                onClick={() => setPaymentStatusFilter("3")}
                className={`px-3 py-1 rounded-full font-medium text-sm transition-all duration-200 ${
                  paymentStatusFilter === "3"
                    ? "bg-gradient-to-r from-primary to-secondary text-white shadow-md"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                }`}
              >
                {translate("myVehicles.paymentStatus.paid")} (
                {paymentStatusCounts.paid})
              </button>
              <button
                onClick={() => setPaymentStatusFilter("4")}
                className={`px-3 py-1 rounded-full font-medium text-sm transition-all duration-200 ${
                  paymentStatusFilter === "4"
                    ? "bg-gradient-to-r from-primary to-secondary text-white shadow-md"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                }`}
              >
                {translate("myVehicles.paymentStatus.cancelled")} (
                {paymentStatusCounts.cancelled})
              </button>
              <button
                onClick={() => setPaymentStatusFilter("5")}
                className={`px-3 py-1 rounded-full font-medium text-sm transition-all duration-200 ${
                  paymentStatusFilter === "5"
                    ? "bg-gradient-to-r from-primary to-secondary text-white shadow-md"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                }`}
              >
                {translate("myVehicles.paymentStatus.refunded")} (
                {paymentStatusCounts.refunded})
              </button>
            </div>
          )}

          {/* Vehicle List */}
          {currentVehicles.length > 0 ? (
            <div className="rounded-lg border border-default overflow-hidden mb-6">
              {/* Table Header */}
              <div className="bg-primary px-4 py-3">
                <div className="grid grid-cols-12 gap-4 text-sm font-medium text-white">
                  <div
                    className={`col-span-1 ${
                      isRTL ? "text-right" : "text-left"
                    }`}
                  >
                    {translate("myVehicles.tableHeaders.image")}
                  </div>
                  <div
                    className={`col-span-3 ${
                      isRTL ? "text-right" : "text-left"
                    }`}
                  >
                    {translate("myVehicles.tableHeaders.vehicleDetails")}
                  </div>
                  <div
                    className={`col-span-1 ${
                      isRTL ? "text-right" : "text-left"
                    }`}
                  >
                    {translate("myVehicles.tableHeaders.price")}
                  </div>
                  {filter === "rejected" ? (
                    <>
                      <div
                        className={`col-span-5 ${
                          isRTL ? "text-right" : "text-left"
                        }`}
                      >
                        {translate("myVehicles.tableHeaders.rejectionReason")}
                      </div>
                      <div
                        className={`col-span-2 ${
                          isRTL ? "text-left" : "text-right"
                        }`}
                      >
                        {translate("myVehicles.tableHeaders.actions")}
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        className={`col-span-1 ${
                          isRTL ? "text-right" : "text-left"
                        }`}
                      >
                        {translate("myVehicles.tableHeaders.miles")}
                      </div>
                      <div
                        className={`col-span-1 ${
                          isRTL ? "text-right" : "text-left"
                        }`}
                      >
                        {translate("myVehicles.tableHeaders.fuel")}
                      </div>
                      <div
                        className={`col-span-1 ${
                          isRTL ? "text-right" : "text-left"
                        }`}
                      >
                        {translate("myVehicles.tableHeaders.cyl")}
                      </div>
                      <div
                        className={`col-span-1 ${
                          isRTL ? "text-right" : "text-left"
                        }`}
                      >
                        {translate("myVehicles.tableHeaders.eng")}
                      </div>
                      <div
                        className={`col-span-1 w-full whitespace-nowrap ${
                          isRTL ? "text-right" : "text-left"
                        }`}
                      >
                        {translate("myVehicles.tableHeaders.updatedAt")}
                      </div>
                      {/* <div className="col-span-1"></div> */}
                      <div className="col-span-1"></div>
                    </>
                  )}
                  {filter !== "rejected" && (
                    <div
                      className={`col-span-1 ${
                        isRTL ? "text-left" : "text-right"
                      }`}
                    >
                      {translate("myVehicles.tableHeaders.actions")}
                    </div>
                  )}
                </div>
              </div>

              {/* Vehicle Items */}
              <div className="divide-y divide-gray-200">
                {currentVehicles.map((vehicle) => (
                  <MyVehicleListView key={vehicle.id} vehicle={vehicle} />
                ))}
              </div>
            </div>
          ) : (
            <div className="text-center py-12 rounded-lg border border-default mb-6">
              <div className="text-gray-400 mb-4">
                <svg
                  className="mx-auto h-12 w-12"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1m-1-1v-4a1 1 0 011-1h2a1 1 0 011 1v4m-6 0V9a1 1 0 011-1h2a1 1 0 011 1v2"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-primary mb-2">
                {translate("myVehicles.noVehiclesFound")}
              </h3>
              <p className="text-white arabic-text">
                {translate("myVehicles.noVehiclesFound")}
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="mb-6">
        <Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </>
  );
};

export default MyVehicles;
